import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import {CommonService} from '../../services/common.service'
import { APIService } from 'src/app/api.service';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-product-units',
  templateUrl: './product-units.component.html',
  styleUrls: ['./product-units.component.scss']
})
export class ProductUnitsComponent implements OnInit {


  prductUnitData:any = {
    productID: 0,
    productName: '',
    primaryUnitID: '0',
    primaryUnitName: '',
    primaryUnitPricision: 0
  };

  productSKU: any;
  xnIDs: string = '';

  constructor(private router: Router, public commonFun: CommonService,
    private apiService: APIService, private dataSer: DataService) { 

      this.dataSer.productUnits.subscribe((value: any) => {
        let val: any = value;
        if(val.productID) {
            this.productUnitData = value;
            this.prductUnitData.productID = this.productUnitData.productID;  
            this.productSKU = this.productUnitData.SKU;
            this.xnIDs = this.productUnitData.XnIDs;
            this.getData();
          }
      });
    }

  
  //#region "Declaration"
  @Input() productUnitData: any;
  @Input() mdlRef: any;
 

  selectedUnits: any = [];

  secondaryPrdUnit: any = [];
  
  jarvisData: any = [];
  unitList: any = [];
  agencyData: any = [];

  //#endregion


  ngOnInit(): void {
    // let productID = this.commonFun.GetParam("PID");
    // this.prductUnitData.productID = productID;
  if(this.productUnitData.productID) {
      this.getData();
    }
  }

  getData() {
    let agencyData = this.apiService.getCookie("M");
    if (agencyData) {
      this.agencyData = JSON.parse(agencyData);
    }
    let jarvis = this.apiService.getCookie("Jarvis");
    if (jarvis) {
          this.jarvisData = JSON.parse(jarvis);
          this.prductUnitData.productName = this.productUnitData.productName;
          this.selectedUnits = JSON.parse(this.productUnitData.Unit);
          
          // this.dataSer.dataTransfer.subscribe((value :any) => {
          //   if(value){
          //     this.prductUnitData.productName = value.productName;
          //     this.selectedUnits = JSON.parse(value.Unit);
          //   }
          // });
          this.getAllUnits();
    };
  }

  //#region "Function"

  //getProductDetail() - Get Product Details
  getAllUnits(){
    let myParams = [{
        myUserID: this.jarvisData[0].UserID,
        myToken: this.jarvisData[0].WebToken,
        forAgencyID: this.jarvisData[0].AgencyIDs,
        myAgencyIDs: this.jarvisData[0].AgencyIDs,
        myLastSyncDT: null,
        isWeb: true,
        ForERPAgencyID: this.agencyData[0].ERPAgencyID,
        actionType: 'getConfig',
        moduleID: 6,
        data: '[]'
    }];

    this.apiService.getData(myParams, this.successResp.bind(this), this.failureResp.bind(this));  
  }

  //failureResp - failure handler
  failureResp(res: any) {
    if (res.error) {
    }
    else {
      this.apiService.successAlert(res.message);
    }
  }

  //successResp - success  get handler
  successResp(res: any) {
    if (res.error) {
    }
    else {
        if (res) {
          var reponseData = JSON.parse(res.updatePackage);
          if(reponseData.Table[0].ErrCode == 1){
              this.apiService.successAlert(reponseData.Table[0].ErrMsg);
              // this.router.navigateByUrl('/Stock');
          }
          else{
            let unitData = reponseData.Table2[0];
            this.unitList = JSON.parse(unitData.Units);

            if(this.unitList.length > 0){
              let skuUnit = this.unitList.filter((a: any) => a.UNm == this.productSKU);
              this.prductUnitData.primaryUnitID = skuUnit[0].UID;
              this.prductUnitData.primaryUnitPricision = skuUnit[0].Prcsn;
              this.prductUnitData.primaryUnitName = skuUnit[0].UNm;
            }
            this.unitList = this.unitList.filter((a: any) => a.UID != this.prductUnitData.primaryUnitID);

            if(this.selectedUnits.length > 0) {
              this.selectedUnits.forEach((element: any) => {
                this.unitList = this.unitList.filter((a: any) => a.UID != element.UID);
              }); 
            }

          }
        }
    }
  }

   //fn_saveProductUnit() - BOM Save
   fn_saveProductUnit() {
    let tempData = [{
      ItemID: this.prductUnitData.productID,
      ChangeType: 'Unit',
      BOM: '[]',
      Byproducts: '[]',
      Stages: '',
      Units: JSON.stringify(this.selectedUnits)
    }];
    let myParams = [{
      myUserID: this.jarvisData[0].UserID,
      myToken: this.jarvisData[0].WebToken,
      forAgencyID: this.jarvisData[0].AgencyIDs,
      myAgencyIDs: this.jarvisData[0].AgencyIDs,
      myLastSyncDT: null,
      isWeb: true,
      ForERPAgencyID: this.agencyData[0].ERPAgencyID,
      actionType: 'setItemDetail',
      moduleID: 5,
      data: JSON.stringify(tempData)
    }];

    this.apiService.sendChange(myParams, this.successBOMEntry.bind(this), this.failureBOMResp.bind(this));
  }

   //failureBOMResp - failure handler
   failureBOMResp(res: any) {
    if (res.error) {
    }
    else {
      this.apiService.successAlert(res.message);
    }
  }

  //successBOMEntry - success  get handler
  successBOMEntry(res: any) {
    if (res.error) {
    }
    else {
        if (res) {
          var reponseData = JSON.parse(res.updatePackage);
          if(reponseData.Table[0].ErrCode == 1){
            this.apiService.successAlert(reponseData.Table[0].ErrMsg);
          }
          else{
            // this.router.navigateByUrl('/ProductDetail?PID=' + this.prductUnitData.productID);
            if(this.mdlRef) {
              this.mdlRef.close('Done');
            }
          }
        }
    }
  }

  //changeSKU() - Unit Change
  changeSKU(){
    let isDuplicate = this.unitList.filter((x: any) => x.UID == this.prductUnitData.primaryUnitID);
    if(isDuplicate.length > 0) {
      this.prductUnitData.primaryUnitPricision = isDuplicate[0].Prcsn;
      this.prductUnitData.primaryUnitName = isDuplicate[0].UNm;
    }
    else{
      this.apiService.successAlert("Please select valid unit.");
      return;
    }
  }

  //fn_changeSecQty() - Batch Ratio
  fn_changeSecQty(){    
    let isDuplicate = this.selectedUnits.filter((x: any) => x.UID == this.secondaryPrdUnit.unitID);
    if(isDuplicate.length > 0) {
      this.apiService.successAlert("This unit already exist");
      return;
    };

    let selectedUnit = this.unitList.filter((x: any) => x.UID == this.secondaryPrdUnit.unitID);
    
    if(this.prductUnitData.primaryUnitID == this.secondaryPrdUnit.unitID){
      this.selectedUnits.push({
        "UID": this.secondaryPrdUnit.unitID,
        "UNm": selectedUnit[0].UNm,
        "Prcsn": selectedUnit[0].Prcsn,
        'Rto': this.commonFun.PrecisionwiseValue('1', this.prductUnitData.primaryUnitPricision),
      });
    }
    else{
      this.selectedUnits.push({
        "UID": this.secondaryPrdUnit.unitID,
        "UNm": selectedUnit[0].UNm,
        "Prcsn": selectedUnit[0].Prcsn,
        'Rto': this.commonFun.PrecisionwiseValue(this.secondaryPrdUnit.ratio + "", this.prductUnitData.primaryUnitPricision)
      });
    };
    this.unitList = this.unitList.filter((a: any) => a.UID != this.secondaryPrdUnit.unitID);

    this.secondaryPrdUnit.unitID = 0;
    this.secondaryPrdUnit.unitName = '';
    this.secondaryPrdUnit.ratio = 1;
    this.secondaryPrdUnit.isOpenRelation = false;

    
  }

  //fn_ChangeUnitRatio() - Change Unit Ratio
  fn_ChangeUnitRatio(obj: any){
    this.secondaryPrdUnit.ratio = this.commonFun.PrecisionwiseValue(this.secondaryPrdUnit.ratio + "", this.prductUnitData.primaryUnitPricision);
  }

  deleteUnit(index: number) {
    this.selectedUnits.splice(index, 1);
  }

  goBack(){
    this.mdlRef.close('Close');
  }


  //#endregion
}
